<template>
  <v-slide-y-transition mode="out-in">
  <v-container class="pt-0 mb-4" id="profile" v-if="partai">
    <v-layout column class="pa-0 ma-0">
      <v-card class="elevation-0">
        <v-layout column align-center justify-center v-bind:style="partai.color ? 'background:'+partai.color : 'background:'+randomColor()">
          <v-progress-circular
            v-if="loading" v-bind:size="200"
            v-bind:width="15" color="info"
            indeterminate class="mt-4"
          ></v-progress-circular>            
          <v-avatar v-if="!loading" size="200" class="mt-4" v-bind:color="partai.color ? partai.color : randomColor()">              
            <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />                
            <v-tooltip bottom  style="position:absolute; top:0px; right:0px">
              <v-btn slot="activator" @click="toggleShow" :loading="loading" fab small indeterminate dark color="yellow">
                <v-icon dark>camera_alt</v-icon>
              </v-btn>
              <span>Upload Foto</span>
            </v-tooltip>              
            <img v-if="partai && partai.avatar" :src="partai.avatar ? partai.avatar: null" >
            <img v-else-if="imageUrl" :src="imageUrl" />     
            <span v-else class="white--text display-4">{{partai.no}}</span>  
          </v-avatar>            
          <h1 class="white--text mt-1 mb-1">{{partai.akronim}}</h1>                        
        </v-layout>                                                               
        <v-card-text class="pa-0">                      
          <v-tabs v-model="selectedTab">
            <v-tab ripple href="#tab-1">
              Profile
            </v-tab>                                  
            <v-tabs-items v-model="selectedTab">
              <v-tab-item value="tab-1">                
                <v-card flat>                   
                  <v-card-text class="pa-0">                                         
                    <v-list two-line class="pa-0">
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">face</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>             
                            {{ partai.no }}                            
                          </v-list-tile-title>
                          <v-list-tile-sub-title>No Urut</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <router-link fab absolute top right :to="{path:'/calon/form', query: $route.query}">
                            <v-tooltip left >
                              <v-btn fab small slot="activator" dark color="cyan">
                                  <v-icon dark>edit</v-icon>
                              </v-btn>  
                              <span>Update Data</span>
                            </v-tooltip>  
                          </router-link>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>          
                      <!--<v-tooltip top>-->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-icon color="indigo">work</v-icon>
                          </v-list-tile-action>                          
                          <v-list-tile-content>
                            <v-list-tile-title>{{partai.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>Name</v-list-tile-sub-title>
                          </v-list-tile-content>                                                      
                        </v-list-tile>
                        <!--<span>Click for Assignment</span>
                      </v-tooltip> --> 
                      <v-divider></v-divider>          
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">phone</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{partai.tagline}}</v-list-tile-title>
                          <v-list-tile-sub-title>Tagline</v-list-tile-sub-title>
                        </v-list-tile-content>                        
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">mail</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{partai.desc}}</v-list-tile-title>
                          <v-list-tile-sub-title>Description</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>                      
                    </v-list>                    
                  </v-card-text>
                </v-card>                
              </v-tab-item>              
            </v-tabs-items>
          </v-tabs>          
        </v-card-text>
      </v-card>         
      <my-upload style="width:100%" field="img"
        @crop-success="cropSuccess"        
          :width="300"
          :height="300"         
          lang-type="en"
          :value.sync="show"
          v-model="show"                
          img-format="png">            
      </my-upload>                
    </v-layout>
  </v-container>    
  </v-slide-y-transition>    
</template>

<script>
import colors   from 'vuetify/es5/util/colors';
import myUpload from 'vue-image-crop-upload';
import Model    from '@/apps/frc/models/Calon';

let model = new Model();


export default {
  components: {     
    'my-upload': myUpload    
  },
  data () {
    return {    
      partai_id : null,      
      selectedTab : null,
      loading : false,
      imageName : '',
      imageUrl : '',
      imageFile : '',
      show : false,            
      imgDataUrl : '' // the datebase64 url of created image
    };
  },    
  asyncComputed: {    
    partai(){
      this.loading = true;
      this.partai_id = this.$route.query.id;
      return model.one({id:this.$route.query.id}).then(res=>{        
        let result = res;
        
        result.cover = require('@/assets/img/bg/'+this.getRandom());
        this.loading = false;    
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl  = '';
        this.getavatar();
        return result;
      });
    },    
    
  },
  methods: {
    firstLetter (name) {
      return name? name.charAt(0): null;
    },
    getRandom(){      
      var randomArray = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      return _.sample(randomArray);
      //return require('@/assets/img/bg/'+randomElement);
    },
    getCover(){
      var randomArray   = ['1.jpg','11.jpg', '12.jpg','13.jpg','14.jpg','16.jpg'];
      var randomElement = _.sample(randomArray);
      return require('@/assets/img/bg/'+randomElement);
    },
    randomColor(){
      var randomArray   = colors;
      var color = _.sample(randomArray);     
      return color.base === undefined ? 'info':color.base;
    },
    onFilePicked (e) {
      const files = e.target.files;
      if(files[0] !== undefined) {
        this.imageName = files[0].name;
        if(this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();                
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl  = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          
          
          var FormData = require('form-data');
          let formData = new FormData();
          
          formData.append('content', files[0], files[0].name);
          formData.append('reff_id', this.partai_id);
          formData.append('reff_type', 1);        
          
          this.loading = true;
          model.setavatar(formData).then(res=>{
            this.getavatar();            
          });
          
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl  = '';
      }
    },
    getavatar(){
      model.getavatar({reff_id:this.partai_id}).then(res=>{
        if(res.data){
          this.imageUrl = res.data;
          this.loading  = false;
        }
      });
    },
    toggleShow() {
        this.show = !this.show;
    },            
    cropSuccess(imgDataUrl, field){
        //console.log('-------- crop success --------');
        this.imgDataUrl = imgDataUrl;
        
        var block = imgDataUrl.split(";");
        var contentType = block[0].split(":")[1];// In this case "image/gif"
        var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
        var blob = this.b64toBlob(realData, contentType);

        var FormData = require('form-data');
        let formData = new FormData();

        formData.append('content', blob, 'userprofile');
        formData.append('reff_id', this.partai_id);             

        this.loading = true;
        model.setavatar(formData).then(res=>{
          this.getavatar();            
        });
    },               
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>
<style>  
  .vue-image-crop-upload .vicp-wrap{      
      height: 70%;
      width : 80%;
      min-height:330px;
      max-width: 600px;
  }
</style>